var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from "react";
export var defaultState = {
    accountId: "",
    isModalOpen: false,
    showEnrollmentError: false,
    isMutationLoading: false,
};
var StatementsContext = createContext({
    state: defaultState,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dispatch: function (_newState) {
        throw new Error("No dispatch");
    },
    handleClose: function () {
        throw new Error("No handleClose()");
    },
    handleProfileClick: function () {
        throw new Error("No handleProfileClick()");
    },
});
StatementsContext.displayName = "StatementsContext";
export var useStatementsContext = function () {
    var value = useContext(StatementsContext);
    if (!value) {
        throw new Error("No context value");
    }
    return value;
};
var StatementsContextProvider = function (_a) {
    var initialState = _a.initialState, handleClose = _a.handleClose, handleProfileClick = _a.handleProfileClick, handleRequestPastStatementsClick = _a.handleRequestPastStatementsClick, children = _a.children;
    var _b = useState(initialState !== null && initialState !== void 0 ? initialState : defaultState), state = _b[0], setState = _b[1];
    var dispatch = useCallback(function (newState) {
        setState(function (prevState) { return (__assign(__assign({}, prevState), newState)); });
    }, []);
    var contextValue = useMemo(function () { return ({
        state: state,
        dispatch: dispatch,
        handleClose: handleClose,
        handleProfileClick: handleProfileClick,
        handleRequestPastStatementsClick: handleRequestPastStatementsClick,
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]);
    /*
     * Added this because when it first renders it will have the default values until the user clicks on the card.
     * Once the User clicks on the card the values will change. Thus we need to trigger a re-render
     */
    useEffect(function () {
        if (initialState &&
            JSON.stringify(state) !== JSON.stringify(initialState)) {
            dispatch(initialState);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialState]);
    return (_jsx(StatementsContext.Provider, __assign({ value: contextValue }, { children: children })));
};
export default StatementsContextProvider;
